import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=316b6cb4"
import script from "./js/leadsScript.js?vue&type=script&lang=js&external"
export * from "./js/leadsScript.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports